export default __webpack_public_path__ + "static/media/CloudBG.494cd2e7.png";